// Case 1: Null/empty name (returns "AB")
// Case 2: Single word names (returns first two letters, or doubles the letter if single character)
// Case 3: Multiple word names (returns first letter of first and last word)
export const getComedianInitials = (name: string | null) => {
  if (!name) return "AB";

  const parts = name.split(" ");
  if (parts.length === 1) {
    // If there's only one word, return first two letters (or first letter twice if single character)
    return name.length === 1 ? `${name[0]}${name[0]}` : `${name[0]}${name[1]}`;
  }

  // Otherwise return first letter of first and last name
  return `${parts[0][0]}${parts[parts.length - 1][0]}`;
};
